import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import PublicNav from "@/components/PublicNav";
import PublicFooter from "@/components/PublicFooter";
import { ArrowRight } from "lucide-react";

const STYLES = ["all", "Coastal", "Coastal Hampton", "Contemporary", "Organic Modern", "Modern Australian", "Minimalist", "Mediterranean", "Dark Luxury", "Stone Feature", "Timber Feature", "Fireplace Integrated"];

export default function DesignsPage() {
  const [items, setItems] = useState([]);
  const [style, setStyle] = useState("all");

  useEffect(() => {
    api.get("/public/designs", { params: style !== "all" ? { style } : {} }).then((r) => setItems(r.data));
  }, [style]);

  return (
    <div className="min-h-screen bg-background" data-testid="designs-page">
      <PublicNav/>
      <div className="pt-32 pb-8 px-6 lg:px-12 max-w-7xl mx-auto">
        <div className="overline">Design Gallery</div>
        <h1 className="font-serif font-light mt-3" style={{ fontSize: "clamp(44px, 6vw, 68px)", lineHeight: 1.05 }}>
          Design studies from our studio.
        </h1>
        <p className="text-muted-foreground mt-4 max-w-2xl">
          A curated set of concept studies exploring the styles, materials and details we compose for our clients. Each of these represents a design direction rather than a completed project.
        </p>

        <div className="flex flex-wrap gap-2 mt-10">
          {STYLES.map((s) => (
            <button key={s} data-testid={`filter-style-${s}`}
              onClick={() => setStyle(s)}
              className={`px-4 py-2 text-xs tracking-wide border ${style === s ? "bg-foreground text-background border-foreground" : "border-input text-muted-foreground hover:text-foreground"}`}>
              {s === "all" ? "All Styles" : s}
            </button>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-12 pb-24 grid md:grid-cols-2 lg:grid-cols-3 gap-8">
        {items.map((d) => (
          <Link key={d.id} to={`/designs/${d.slug}`} data-testid={`design-card-${d.slug}`}
            className="group block">
            <div className="aspect-[4/5] bg-muted overflow-hidden">
              <img src={d.hero_unsplash} alt={d.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"/>
            </div>
            <div className="mt-4">
              <div className="overline text-[10px]">{d.style}</div>
              <div className="font-serif text-2xl mt-2">{d.title}</div>
              <div className="text-xs text-muted-foreground mt-1">DESIGN STUDY</div>
              <div className="text-sm mt-2">${d.indicative_investment_min.toLocaleString()} – ${d.indicative_investment_max.toLocaleString()}</div>
            </div>
          </Link>
        ))}
      </div>

      <PublicFooter/>
    </div>
  );
}
